<template lang="pug">
div.team
  h1.page-title MitarbeiterInnen
  div.team-members.w-flex.wrap
    template(v-for="member in mitarbeiter")
      div.team-member.w-flex
        div.team-image.w-flex
          w-image(
            tag="img"
            :src="member.image"
            width="100%"
          )
        div.team-content.w-flex.column
          h2.team-name {{member.name}}
          div.team-role {{member.role}}
          div.team-email(
            v-if="member.email"
          ) 
            w-icon.mr2(
              color="black"
            ) mdi mdi-email
            a(
              :href="'mailto:'+member.email"
            ) E-Mail
    div.team-member.dummy
  p &nbsp;
  h1.page-title AnsprechpartnerInnen
  div.team-members.w-flex.wrap
    template(v-for="member in ansprechpartner")
      div.team-member.w-flex
        div.team-image.w-flex
          w-image(
            tag="img"
            :src="member.image"
            width="100%"
          )
        div.team-content.w-flex.column
          h2.team-name {{member.name}}
          div.team-role {{member.role}}
          div.team-email(
            v-if="member.email"
          ) 
            w-icon.mr2(
              color="black"
            ) mdi mdi-email
            a(
              :href="'mailto:'+member.email"
            ) E-Mail
    div.team-member.dummy
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Team',
  data() {
    return {
      mitarbeiter: [
        { name: "Sandra Peter", role: "Erzieherin, Sozialarbeiterin, Leiterin der Schmetterlinge", image: require('@/assets/profilbilder/sandrapeter.jpg')},
        { name: "Elke Rathmann", role: "Erzieherin", image: require('@/assets/profilbilder/elkerathmann.jpg')},
        { name: "Tanja Röhm", role: "Erzieherin", image: require('@/assets/profilbilder/tanjaroehm.jpg')},
        { name: "Cornelia Stahl", role: "Erzieherin", image: require('@/assets/profilbilder/corneliastahl.jpg')},
        //{ name: "Claudia Schouten", role: " ", image: require('@/assets/profilbilder/claudiaschouten.jpg')},
        //{ name: "Silke Schramm", role: "Erzieherin", image: require('@/assets/profilbilder/silkeschramm.jpg')}
      ],
      ansprechpartner: [
        { name: "Sarah Brenner-Kußmaul", role: "1. Vorsitzende", image: require('@/assets/profilbilder/sarahbrennerkussmaul.jpeg')},
        { name: "Sandra Weißflog", role: "2. Vorsitzende", image: require('@/assets/profilbilder/sandraweissflog.jpeg')},
        { name: "Lisa Tietzsch", role: "Anmeldeliste", image: require('@/assets/profilbilder/lisatietzsch.jpg'), email:"anmeldung@schmetterlinge-herrenberg.de"},
        { name: "Sonja Augustin", role: "Schatzmeisterin", image: require('@/assets/profilbilder/sonjaaugustin.jpeg')},
        { name: "Sophie Artmann", role: "Schriftführerin", image: require('@/assets/profilbilder/sophieartmann.jpeg')},
        { name: "Björn Heinzelmann", role: "zusätzliche Vereinstätigkeiten", image: require('@/assets/profilbilder/bjoernheinzelmann.jpg')}
      ]
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      viewport: 'viewport'
    }),
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss">
.team {
  padding-top: 20px;
  .page-title {
    padding: 0px 20px;
    padding-bottom: 20px;
  }
  .team-member {
    flex-basis: 400px;
    flex-grow: 1;
  }
  .team-image{ 
    padding: 20px;
    width: 40%;
    max-width: 240px;
    align-items: center;
    img {
      width: 100%;
      height: auto;
      border-radius: 9999px;
    }
  }
  .team-content {
    width: 60%;
    justify-content: center;
    padding: 20px;
  }
  .team-name {
    font-size: 25px!important;
  }
  .team-email {
    padding-top: 10px;
  }
}
</style>
